import { render, staticRenderFns } from "./menu-main.vue?vue&type=template&id=6eec642a&"
import script from "./menu-main.vue?vue&type=script&lang=ts&"
export * from "./menu-main.vue?vue&type=script&lang=ts&"
import style0 from "./menu-main.vue?vue&type=style&index=0&id=6eec642a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports